<template>
  <div>
    <a-card :title="$t('带队成员')" size="small" style="margin-bottom:10px;border-radius:5px;" v-if="leaders != null && leaders.length > 0">
        <a-card-grid style="width:100px;text-align:center;padding:20px;" v-for="(item,index) in leaders" :key="index">
            <img style="width:50px;height:60px;border-radius:5px;" :src="item.head"/>
            {{ item.name }} <br/>
            <a-tag style="margin:0;">{{ $t(matchFun.getLeaderName(item.type)) }}</a-tag>
        </a-card-grid>
    </a-card>
  </div>
</template>
<script>
import store from '@/store'
import matchFun from '@comm/utils/matchFun'
export default {
  components: {
  },
  data () {
    return {
      matchFun: matchFun,
      teamId: Number(this.$route.query.teamId),
      matchInfo: store.getters['match/matchInfo'],
      leaders: []
    }
  },
  mounted () {
    if (this.teamId !== -1 && this.matchInfo.mode !== 'ONLINE') {
      this.findLeaders()
    }
  },
  methods: {
    findLeaders () {
      this.$api.join.queryJoinedLeaders({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId || -1}).then(res => {
        if (res.status === 0) {
          this.leaders = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/staff/TeamLeader.vue